const PLACES: { [key: string]: string } = {
    CHICAGO: '85940195',
    LONDON: '101750367',
    LOS_ANGELES: '85923517',
    NEW_YORK: '85977539',
    SAN_FRANCISCO: '85922583',
    WASHINGTON_DC: '85931779',
};

// production event IDs mapping
export const FEATURE_EVENTS_MAPPING: { [key: string]: any } = {
    [PLACES.CHICAGO]: [
        '616007112857',
        '643712670927',
        '571036885697',
        '586233920437',
        '625680817167',
        '631799418067',
        '595987353217',
        '637627319477',
        '633998856647',
        '629300644167',
    ],
    [PLACES.LONDON]: [
        '626275094667',
        '491748160987',
        '625273890037',
        '639189943327',
        '639278588467',
        '641989878007',
        '503551886247',
        '524321197817',
        '649704412387',
    ],
    [PLACES.LOS_ANGELES]: [
        '608701010107',
        '650415459147',
        '536227459767',
        '617702042437',
        '622066917897',
        '635966712557',
        '637847417797',
        '611511807277',
        '637901058237',
        '634523064567',
    ],
    [PLACES.NEW_YORK]: [
        '576336276317',
        '628789003837',
        '454024789367',
        '534136044287',
        '616513758247',
        '654247460767',
        '622037199007',
        '643158603697',
        '631816278497',
        '637435716387',
        '653068434267',
    ],

    [PLACES.SAN_FRANCISCO]: [
        '628849484737',
        '634956109817',
        '579554461997',
        '616720296007',
        '624866421287',
        '634917815277',
        '641530293377',
        '647432416787',
        '597265105007',
        '645042809407',
    ],
    [PLACES.WASHINGTON_DC]: [
        '511063573907',
        '595420668247',
        '639578756277',
        '466847873557',
        '648103062707',
        '635647277117',
        '646469647117',
        '667536558817',
        '554436413237',
        '646507771147',
        '568184524207',
    ],
};
